import { css } from "@linaria/core";

export const wrapper = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;

  @media (min-width: 768px) {
    &[data-card-count="1"] {
      margin: 0 auto;
      max-width: calc(50% - 15px);
    }
  }
`;

export const heading = css`
  font-family: figtree, helvetica, arial, sans-serif;
  font-weight: bold;
  font-size: 35px;
  line-height: 1;

  margin: 0;

  &.scrambled {
    background-color: transparent !important;
    background-image: url("data:image/svg+xml,%3Csvg width='1' height='40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg%3E%3Crect opacity='0.1' id='scramble-bg' height='20' width='1' y='10' x='0' stroke-width='1.5' stroke='%23000' fill='%23fff'/%3E%3C/g%3E%3C/svg%3E%0A") !important;
    background-size: contain !important;
    background-repeat: repeat-x !important;

    color: rgba(0, 0, 0, 0) !important;

    user-select: none !important;
  }
`;

export const cardsList = css`
  width: 100%;

  padding: 0;
  margin: 0;

  display: grid;
  grid-auto-rows: repeat(4, 1fr);
  gap: 30px;

  margin: 0;
  list-style: none;

  /** See ADO #103778 for grid specification  */
  @media (min-width: 1024px) {
    .${wrapper}[data-card-count="1"] & {
      grid-template-columns: repeat(1, 1fr);
      gap: 30px;
    }

    .${wrapper}[data-card-count="2"] & {
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
    }

    .${wrapper}[data-card-count="3"] &,
    .${wrapper}[data-card-count="5"] &,
    .${wrapper}[data-card-count="6"] &,
    .${wrapper}[data-card-count="9"] & {
      grid-template-columns: repeat(3, 1fr);
    }

    .${wrapper}[data-card-count="4"] &,
    .${wrapper}[data-card-count="7"] &,
    .${wrapper}[data-card-count="8"] &,
    .${wrapper}[data-card-count="10"] {
      grid-template-columns: repeat(4, 1fr);
      font-size: 24px;
    }
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    .${wrapper}[data-card-count="1"] & {
      grid-template-columns: repeat(1, 1fr);
    }

    .${wrapper}[data-card-count="2"] &,
    .${wrapper}[data-card-count="4"] & {
      grid-template-columns: repeat(2, 1fr);
    }

    .${wrapper}[data-card-count="3"] &,
    .${wrapper}[data-card-count="5"] &,
    .${wrapper}[data-card-count="6"] &,
    .${wrapper}[data-card-count="7"] &,
    .${wrapper}[data-card-count="8"] &,
    .${wrapper}[data-card-count="9"] &,
    .${wrapper}[data-card-count="10"] {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
  }
`;

export const card = css`
  @media (max-width: 767px) {
    width: 100%;
  }
`;
